import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";

export function QuoteSection() {
  return (
    <section id="quote" data-testid="quote-section" className="py-24 lg:py-32 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <motion.div
            className="lg:sticky lg:top-24"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary mb-4">
              Free Quote
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight font-bold text-foreground">
              Tell Us What Your Chimney Needs
            </h2>
            <p className="text-base text-muted-foreground mt-4 leading-relaxed max-w-md">
              Repair, crown, cap, flashing, or tuckpointing — send us your name and
              number and we'll call you back with a straight answer and a fair price.
            </p>
            <div className="mt-8 flex items-center gap-4">
              <span className="w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                <Phone className="w-6 h-6 text-primary" strokeWidth={1.5} />
              </span>
              <div>
                <p className="text-sm text-muted-foreground">Prefer to talk?</p>
                <a
                  href="tel:+19712553874"
                  data-testid="quote-call-link"
                  className="font-heading font-bold text-lg text-foreground hover:text-primary transition-colors"
                >
                  971-255-3874
                </a>
              </div>
            </div>
          </motion.div>
          <div className="bg-card border border-border rounded-md p-8" data-testid="quote-form-card">
            <LeadForm variant="quote" />
          </div>
        </div>
      </div>
    </section>
  );
}
